module.exports = __webpack_public_path__ + "img/initialRegistration.487bedf3.svg";